export const FOLDER_USER_ROLE = {
  VIEWER: {
    TYPE: 1,
  },
  EDITOR: {
    TYPE: 2,
  },
};

export const STORY_USER_RELATION = {
  VIEWER: {
    TYPE: 0,
  },
  OWNER: {
    TYPE: 1,
  },
  ROLE: {
    TYPE: 2,
  },
  FOLDER_OWNER: {
    TYPE: 3,
  },
  FOLDER_EDITOR: {
    TYPE: 4,
  },
  FOLDER_ADVANCED_EDITOR: {
    TYPE: 5,
  },
  FOLDER_VIEWER: {
    TYPE: 6,
  },
  ASSIGNE: {
    TYPE: 7,
  },
};

export const APP_USER_ROLE = {
  SUPER_ADMIN: {
    TYPE: 4,
    name: 'company.settings.users.superadmin',
    appcuesTag: 'superadmin',
  },
  MANAGER: {
    TYPE: 3,
    name: 'company.settings.users.cms_manager',
    appcuesTag: 'manager',
  },
  REVIEWER: {
    TYPE: 1,
    name: 'company.settings.users.reviewer',
    appcuesTag: 'reviewer',
  },
  CREATOR: {
    TYPE: 2,
    name: 'company.settings.users.app_user',
    appcuesTag: 'app_user',
  },
  GUEST: {
    TYPE: 5,
    name: 'company.settings.users.guest',
    appcuesTag: 'guest_user',
  },
  VIDEO_EDITOR: {
    TYPE: 6,
    name: 'company.settings.users.video_editor',
    appcuesTag: 'video_editor_user',
  },
};
